module.exports = __webpack_public_path__ + "img/awards_image_13.8b3c07c5.jpg";